import Vue from 'vue';
import Vuex from 'vuex';

import shared from './modules/shared';
import users from './modules/users';

Vue.use(Vuex);

export default new Vuex.Store({
  // to fix below error turn "strict" to "false"
  // Error: [vuex] Do not mutate vuex store state outside mutation handlers
  // read more here: https://vuex.vuejs.org/guide/strict.html
  strict: false,

  // state: { },
  // mutations: { },
  // actions: { },
  // getters: { },
  modules: { shared, users },
});
